// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React, { useContext } from 'react';
import { RadioGroup, Option } from '@op/opds.opux';
import { adminDataTemplate, ContextWrapper, ContractData } from '../../context/ContextWrapper';
import message from '../../messages';
import { AgreementTypes } from '../../Constants';

const AgreementTypesInfoSelection: React.FC = () => {
    const { contractData, updateInformation } = useContext(ContextWrapper);

    const modifyState = (variable: keyof ContractData, showAgreementTypes: boolean): void => {
        updateInformation((state: any) => {
            const companyData = { ...state.companyData };
            companyData.companyTypes = showAgreementTypes ? [] : [AgreementTypes.COMPANY];
            const newAdmin = [adminDataTemplate(showAgreementTypes)];
            return {
                ...state,
                companyData,
                administrators: newAdmin,
                [variable]: showAgreementTypes,
            };
        });
    };

    return (
        <section className="agreement-types-info-section" data-testid="agreementTypesInfoSelectionSection">
            <div className="agreement-types-info-selection" data-testid="agreementTypesInfoSelection">
                <div className="opux-spacing-bottom-margin">
                    <h3 className="opux-heading-3 opux-spacing-bottom-margin">
                        {message('agreementTypesSelectionHeading')}
                    </h3>
                    <ul className="opux-spacing-bottom-margin">
                        <li>{message('agreementTypesSelectionPoint1')}</li>
                        <li>{message('agreementTypesSelectionPoint2')}</li>
                        <li>{message('agreementTypesSelectionPoint3')}</li>
                    </ul>
                </div>

                <RadioGroup
                    id="show-agreement-types"
                    name="showAgreementTypes"
                    value={contractData.showAgreementTypes ? 'yes' : 'no'}
                    onChange={(_ev: any, value: string) => {
                        modifyState('showAgreementTypes', value === 'yes');
                    }}
                    data-testid="showAgreementTypesRadioGroup"
                    wrap
                >
                    <Option value="yes" data-testid="showAgreementTypesYes">
                        {message('yes')}
                    </Option>
                    <Option value="no" data-testid="showAgreementTypesNo">
                        {message('no')}
                    </Option>
                </RadioGroup>
            </div>
        </section>
    );
};

export default AgreementTypesInfoSelection;
